import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { submitLead } from '../actions/bookingActions';

export default function LeadForm({ booking }) {
  const dispatch = useDispatch();
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: `I'm interested in the ${booking.year} ${booking.make} ${booking.model}.`, intent: 'inquiry' });
  const [status, setStatus] = useState({ kind: '', text: '' });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await dispatch(submitLead({ ...form, booking: booking._id }));
    setLoading(false);
    if (res.ok) {
      setStatus({ kind: 'success', text: 'Thanks. Someone will reach out within a business day.' });
      setForm({ ...form, message: '' });
    } else {
      setStatus({ kind: 'error', text: res.error });
    }
  };

  return (
    <form className="lead-form" onSubmit={submit}>
      <h3>Interested? Let us know.</h3>
      <label>Name<input required value={form.name} onChange={update('name')} /></label>
      <label>Email<input required type="email" value={form.email} onChange={update('email')} /></label>
      <label>Phone (optional)<input type="tel" value={form.phone} onChange={update('phone')} /></label>
      <label>Reason
        <select value={form.intent} onChange={update('intent')}>
          <option value="inquiry">General inquiry</option>
          <option value="test-drive">Schedule a test drive</option>
          <option value="financing">Financing question</option>
          <option value="offer">Make an offer</option>
        </select>
      </label>
      <label>Message<textarea rows="3" value={form.message} onChange={update('message')} /></label>
      <button className="btn-primary" type="submit" disabled={loading}>{loading ? 'Sending…' : 'Send'}</button>
      {status.text && <p className={`status ${status.kind}`}>{status.text}</p>}
    </form>
  );
}
